import React from "react"
import { Col, Label, Row, Form } from "reactstrap";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { onupdateAccess } from "store/accessgroupsetting/action";
import CustomRadionButton from "../Components/CustomRadioButton";

const AccessGroupForm = ({
    isEdit, handleCancel, toggle, selectedRow, companySetting
}) => {
    const dispatch = useDispatch();

    // Form - validation 
    const validation = useFormik(
        {
            // enableReinitialize : use this flag when initial values needs to be changed
            enableReinitialize: true,
            initialValues: {
                id: selectedRow.id,
                priority: selectedRow.priority,
                accessgroupid: selectedRow.accessgroupid,
                accessGroupName: isEdit ? (selectedRow && selectedRow.accessGroupName) : '',
                reportRestrictedCategory: isEdit ? (selectedRow && selectedRow.reportRestrictedCategory) : '',
                accessAllTeam: isEdit ? (selectedRow && selectedRow.accessAllTeam) : '',
                blockUser: isEdit ? (selectedRow && selectedRow.blockUser) : '',
                changeOtherUserHrs: isEdit ? (selectedRow && selectedRow.changeOtherUserHrs) : '',
                createMainCat: isEdit ? (selectedRow && selectedRow.createMainCat) : '',
                createSubCat: isEdit ? (selectedRow && selectedRow.createSubCat) : '',
                createTrackProfile: isEdit ? (selectedRow && selectedRow.createTrackProfile) : '',
                createTeam: isEdit ? (selectedRow && selectedRow.createTeam) : '',
                createUser: isEdit ? (selectedRow && selectedRow.createUser) : '',
                deleteUserData: isEdit ? (selectedRow && selectedRow.deleteUserData) : '',
                deleteUserScreen: isEdit ? (selectedRow && selectedRow.deleteUserScreen) : '',
                inviteUser: isEdit ? (selectedRow && selectedRow.inviteUser) : '',
                onEvaluationHrsApproval: isEdit ? (selectedRow && selectedRow.onEvaluationHrsApproval) : '',
                tracHrs: isEdit ? (selectedRow && selectedRow.tracHrs) : '',
                tracReport: isEdit ? (selectedRow && selectedRow.tracReport) : '',
                tracScreenLiveView: isEdit ? (selectedRow && selectedRow.tracScreenLiveView) : '',
                tracScreenView: isEdit ? (selectedRow && selectedRow.tracScreenView) : '',
                viewAllReport: isEdit ? (selectedRow && selectedRow.viewAllReport) : '',
                adminReports: isEdit ? (selectedRow && selectedRow.adminReports) : '',
                webhook: isEdit ? (selectedRow && selectedRow.webhook) : '',
            },
            validationSchema: Yup.object({
                accessGroupName: Yup.string().required("Please Enter Access Group name"),
            }),

            onSubmit: (values) => {
                if (isEdit) {
                    const updateAcess = {
                        id: values.id,
                        accessGroupName: values?.accessGroupName,
                        reportRestrictedCategory: values?.reportRestrictedCategory,
                        priority: values?.priority,
                        accessgroupid: values?.accessgroupid,
                        accessAllTeam: values?.accessAllTeam,
                        blockUser: values?.blockUser,
                        changeOtherUserHrs: values?.changeOtherUserHrs,
                        createMainCat: values?.createMainCat,
                        createSubCat: values?.createSubCat,
                        createTrackProfile: values?.createTrackProfile,
                        createTeam: values?.createTeam,
                        createUser: values?.createUser,
                        deleteUserData: values?.deleteUserData,
                        deleteUserScreen: values?.deleteUserScreen,
                        inviteUser: values?.inviteUser,
                        onEvaluationHrsApproval: values?.onEvaluationHrsApproval,
                        tracHrs: values?.tracHrs,
                        tracReport: values?.tracReport,
                        tracScreenLiveView: values?.tracScreenLiveView,
                        tracScreenView: values?.tracScreenView,
                        viewAllReport: values?.viewAllReport,
                        adminReport: values?.adminReports,
                        webhook: values?.webhook,
                        
                    };
                    // update customer
                    dispatch(onupdateAccess(updateAcess, handleResponse));
                } else {
                    const newAccess = {
                        accessGroupName: values?.accessGroupName,
                        accessAllTeam: values?.accessAllTeam,
                        blockUser: values?.blockUser,
                        changeOtherUserHrs: values?.changeOtherUserHrs,
                        createMainCat: values?.createMainCat,
                        createSubCat: values?.createSubCat,
                        createTrackProfile: values?.createTrackProfile,
                        createTeam: values?.createTeam,
                        createUser: values?.createUser,
                        deleteUserData: values?.deleteUserData,
                        deleteUserScreen: values?.deleteUserScreen,
                        inviteUser: values?.inviteUser,
                        onEvaluationHrsApproval: values?.onEvaluationHrsApproval,
                        tracHrs: values?.tracHrs,
                        tracReport: values?.tracReport,
                        tracScreenLiveView: values?.tracScreenLiveView,
                        tracScreenView: values?.tracScreenView,
                        viewAllReport: values?.viewAllReport,
                        adminReports: values?.adminReports,
                        webhook: values?.webhook,
                    };
                }
            },
        });
    const handleResponse = (status) => {
        if (status === 'SUCCESS') {
            toggle();
            validation.resetForm();
        }
    }
    return <Form
        onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
        }}
    >
        <Row form>
            <Col className="col-12">
                <div className="mb-3">
                    <Label className="form-label">Access Group Name : {selectedRow.accessGroupName}</Label>
                </div>
                <Row>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Trac Screen Live View </Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('tracScreenLiveView', value.target.checked)}
                                defaultChecked={validation.values.tracScreenLiveView === true}
                                name="tracScreenLiveView"
                                id="tracScreenLiveView1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('tracScreenLiveView', !value.target.checked)}
                                defaultChecked={validation.values.tracScreenLiveView === false}
                                name="tracScreenLiveView"
                                id="tracScreenLiveView2"
                                label="No"
                            />
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Report Restricted {companySetting?.MainCategory} </Label>
                            <CustomRadionButton
                                name="reportRestrictedCategory"
                                onChange={(value) => validation.setFieldValue('reportRestrictedCategory', value.target.checked)}
                                defaultChecked={validation.values.reportRestrictedCategory === true}
                                id="reportRestrictedCategory1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                name="reportRestrictedCategory"
                                onChange={(value) => validation.setFieldValue('reportRestrictedCategory', !value.target.checked)}
                                defaultChecked={validation.values.reportRestrictedCategory === false}
                                id="reportRestrictedCategory2"
                                label="No"
                            />
                        </div>
                    </Col>

                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Trac Screen View </Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('tracScreenView', value.target.checked)}
                                defaultChecked={validation.values.tracScreenView === true}
                                name="tracScreenView"
                                id="tracScreenView1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('tracScreenView', !value.target.checked)}
                                defaultChecked={validation.values.tracScreenView === false}
                                name="tracScreenView"
                                id="tracScreenView2"
                                label="No"
                            />
                        </div>
                    </Col>
                </Row>

                <Row>

                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">On Evaluation Hours Approval </Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('onEvaluationHrsApproval', value.target.checked)}
                                defaultChecked={validation.values.onEvaluationHrsApproval === true}
                                name="onEvaluationHrsApproval"
                                id="onEvaluationHrsApproval1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('onEvaluationHrsApproval', !value.target.checked)}
                                defaultChecked={validation.values.onEvaluationHrsApproval === false}
                                name="onEvaluationHrsApproval"
                                id="onEvaluationHrsApproval2"
                                label="No"
                            />
                        </div>

                    </Col>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Trac Report </Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('tracReport', value.target.checked)}
                                defaultChecked={validation.values.tracReport === true}
                                name="tracReport"
                                id="tracReport1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('tracReport', !value.target.checked)}
                                defaultChecked={validation.values.tracReport === false}
                                name="tracReport"
                                id="tracReport2"
                                label="No"
                            />
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Trac Hours </Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('tracHrs', value.target.checked)}
                                defaultChecked={validation.values.tracHrs === true}
                                name="tracHrs"
                                id="tracHrs1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('tracHrs', !value.target.checked)}
                                defaultChecked={validation.values.tracHrs === false}
                                name="tracHrs"
                                id="tracHrs2"
                                label="No"
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Create {companySetting?.MainCategory} </Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('createMainCat', value.target.checked)}
                                defaultChecked={validation.values.createMainCat === true}
                                name="createMainCat"
                                id="createMainCat1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('createMainCat', !value.target.checked)}
                                defaultChecked={validation.values.createMainCat === false}
                                name="createMainCat"
                                id="createMainCat2"
                                label="No"
                            />
                        </div>

                    </Col>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Create {companySetting?.SubCategory} </Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('createSubCat', value.target.checked)}
                                defaultChecked={validation.values.createSubCat === true}
                                name="createSubCat"
                                id="createSubCat1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('createSubCat', !value.target.checked)}
                                defaultChecked={validation.values.createSubCat === false}
                                name="createSubCat"
                                id="createSubCat2"
                                label="No"
                            />
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Create Track Profile </Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('createTrackProfile', value.target.checked)}
                                defaultChecked={validation.values.createTrackProfile === true}
                                name="createTrackProfile"
                                id="createTrackProfile1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('createTrackProfile', !value.target.checked)}
                                defaultChecked={validation.values.createTrackProfile === false}
                                name="createTrackProfile"
                                id="createTrackProfile2"
                                label="No"
                            />
                        </div>

                    </Col>
                </Row>

                <Row>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Change Other User Hours </Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('changeOtherUserHrs', value.target.checked)}
                                defaultChecked={validation.values.changeOtherUserHrs === true}
                                name="changeOtherUserHrs"
                                id="changeOtherUserHrs1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('changeOtherUserHrs', !value.target.checked)}
                                defaultChecked={validation.values.changeOtherUserHrs === false}
                                name="changeOtherUserHrs"
                                id="changeOtherUserHrs2"
                                label="No"
                            />
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Invite User </Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('inviteUser', value.target.checked)}
                                defaultChecked={validation.values.inviteUser === true}
                                name="inviteUser"
                                id="inviteUser1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('inviteUser', !value.target.checked)}
                                defaultChecked={validation.values.inviteUser === false}
                                name="inviteUser"
                                id="inviteUser2"
                                label="No"
                            />
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Create User </Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('createUser', value.target.checked)}
                                defaultChecked={validation.values.createUser === true}
                                name="createUser"
                                id="createUser1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('createUser', !value.target.checked)}
                                defaultChecked={validation.values.createUser === false}
                                name="createUser"
                                id="createUser2"
                                label="No"
                            />
                        </div>

                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Block User </Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('blockUser', value.target.checked)}
                                defaultChecked={validation.values.blockUser === true}
                                name="blockUser"
                                id="blockUser1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('blockUser', !value.target.checked)}
                                defaultChecked={validation.values.blockUser === false}
                                name="blockUser"
                                id="blockUser2"
                                label="No"
                            />
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Delete User Data</Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('deleteUserData', value.target.checked)}
                                defaultChecked={validation.values.deleteUserData === true}
                                name="deleteUserData"
                                id="deleteUserData1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('deleteUserData', !value.target.checked)}
                                defaultChecked={validation.values.deleteUserData === false}
                                name="deleteUserData"
                                id="deleteUserData2"
                                label="No"
                            />
                        </div>

                    </Col>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Delete User Screen</Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('deleteUserScreen', value.target.checked)}
                                defaultChecked={validation.values.deleteUserScreen === true}
                                name="deleteUserScreen"
                                id="deleteUserScreen1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('deleteUserScreen', !value.target.checked)}
                                defaultChecked={validation.values.deleteUserScreen === false}

                                name="deleteUserScreen"
                                id="deleteUserScreen2"
                                label="No"
                            />
                        </div>

                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">View All Report</Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('viewAllReport', value.target.checked)}
                                defaultChecked={validation.values.viewAllReport === true}
                                name="viewAllReport"
                                id="viewAllReport1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('viewAllReport', !value.target.checked)}
                                defaultChecked={validation.values.viewAllReport === false}
                                name="viewAllReport"
                                id="viewAllReport2"
                                label="No"
                            />
                        </div>
                        <div className="mb-3">
                            <Label className="d-block ">Admin Report</Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('adminReports', value.target.checked)}
                                defaultChecked={validation.values.adminReports === true}
                                name="adminReports"
                                id="adminReports1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('adminReports', !value.target.checked)}
                                defaultChecked={validation.values.adminReports === false}
                                name="adminReports"
                                id="adminReports2"
                                label="No"
                            />
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Access All Team</Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('accessAllTeam', value.target.checked)}
                                defaultChecked={validation.values.accessAllTeam === true}
                                name="accessAllTeam"
                                id="accessAllTeam1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('accessAllTeam', !value.target.checked)}
                                defaultChecked={validation.values.accessAllTeam === false}
                                name="accessAllTeam"
                                id="accessAllTeam2"
                                label="No"
                            />
                        </div>
                        <div className="mb-3">
                            <Label className="d-block ">Webhook</Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('webhook', value.target.checked)}
                                defaultChecked={validation.values.webhook === true}
                                name="webhook"
                                id="webhook1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('webhook', !value.target.checked)}
                                defaultChecked={validation.values.webhook === false}
                                name="webhook"
                                id="webhook2"
                                label="No"
                            />
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className="mb-3">
                            <Label className="d-block ">Create Team</Label>
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('createTeam', value.target.checked)}
                                defaultChecked={validation.values.createTeam === true}
                                name="createTeam"
                                id="createTeam1"
                                label="Yes"
                            />
                            <CustomRadionButton
                                onChange={(value) => validation.setFieldValue('createTeam', !value.target.checked)}
                                defaultChecked={validation.values.createTeam === false}
                                name="createTeam"
                                id="createTeam2"
                                label="No"
                            />
                        </div>
                    </Col>
                </Row>

            </Col>

        </Row>
        <div className="text-end">
            <button
                type="submit"
                className="btn btn-primary save-customer me-2"
            >
                Save
            </button>
            <button
                type="button"
                color="primary"
                className="btn btn-secondary"
                onClick={handleCancel}
            >
                Cancel
            </button>
        </div>
    </Form>
}

export default AccessGroupForm;